import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@pirouette/db';
import { env } from '@/env';

// Single typed client instance for the lifetime of the page.
// Per plan §9 decision #2: this is the only place we instantiate Supabase.
// Hooks in src/data/* consume this through TanStack Query.

export const supabase: SupabaseClient<Database> = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storage: typeof window === 'undefined' ? undefined : window.localStorage,
      storageKey: 'pirouette.auth',
    },
    db: { schema: 'public' },
    global: {
      headers: {
        'x-application': 'pirouette-web',
      },
    },
  },
);

export type PirouetteClient = typeof supabase;
